module.exports = __webpack_public_path__ + "img/promotion_1.9c9e284d.png";